import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDate } from "@/pages/Blog";

export default function BlogPost() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (user === null) return;
    const url = user ? `/blog/${slug}` : `/blog/${slug}/preview`;
    api.get(url).then((r) => setPost(r.data)).catch(() => setMissing(true));
  }, [slug, user]);

  if (missing) return <p data-testid="post-missing" className="text-center py-40 font-serif-h text-3xl text-[#577731]">This teaching could not be found.</p>;
  if (!post) return <p className="text-center py-40 text-[#232b1b]/60">Opening the page…</p>;

  const paragraphs = (post.body || post.preview).split("\n\n");
  return (
    <article data-testid="blog-post-page" className="max-w-3xl mx-auto px-6 pt-20">
      <Link to="/blog" className="text-sm text-[#b6689a] hover:underline" data-testid="back-to-blog">← All teachings</Link>
      <span className="eyebrow block mt-10">{fmtDate(post.published_at)}</span>
      <h1 data-testid="post-title" className="font-serif-h font-light text-4xl sm:text-5xl lg:text-6xl text-[#577731] leading-[1.1] mt-4">{post.title}</h1>
      <div data-testid="post-body" className="prose-sacred mt-12 text-lg text-[#232b1b]/85">
        {paragraphs.map((p, i) => <p key={i} className={i === 0 ? "font-serif-h text-2xl text-[#232b1b]" : ""}>{p}</p>)}
      </div>
      {post.body && post.image && <img src={post.image} alt={post.title} data-testid="post-image" className="rounded-3xl w-full mt-8" />}
      {!post.body && (
        <div data-testid="post-gate" className="relative mt-4 rounded-3xl bg-[#dacac1]/45 p-10 text-center">
          <Lock className="mx-auto text-[#b6689a]" />
          <p className="font-serif-h text-2xl text-[#232b1b] mt-4">The rest of this teaching is held within the circle.</p>
          <Link to={`/ambassadors?next=/blog/${slug}#join`} data-testid="post-gate-btn" className="btn btn-mauve mt-8">Apply to Become a Healing Ambassador to keep reading</Link>
        </div>
      )}
    </article>
  );
}
